import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.134}
      d="m6.188 13.924-3.043-3.826c-.305-.403-.102-1.007.355-1.107l4.767-1.31a.8.8 0 0 0 .406-.301l2.738-4.078c.304-.403.913-.403 1.167 0l2.738 4.078a.8.8 0 0 0 .406.302l4.767 1.309c.507.15.66.704.355 1.107L17.8 13.924a.8.8 0 0 0-.152.453l.203 4.883a.745.745 0 0 1-.964.705s-6.593-1.36-6.694-4.229c-.152-2.819 5.68-2.165 1.521 3.474C10.092 21.425 5 19.965 7 17"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.134}
      d="M16.888 19.965s-6.593-1.36-6.694-4.229c-.152-2.819 5.68-2.165 1.521 3.474C10.093 21.425 5 19.965 7 17"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const StarIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
